<script setup>
import { onMounted, ref } from "vue";

import AppAlert from "@/components/AppAlert";
import AppAlertCard from "@/components/AppAlertCard";
import AppButton from "@/components/AppButton";
import AppFormInput from "@/components/Form/AppFormInput";
import AppCard from "@/components/AppCard";
import AppGuestHeader from "@/components/AppGuestHeader";

import { store } from "@/store";

import getFormFields from "@/utils/getFormFields";

// Api
import useApi from "@/composables/useApi";
const { user } = useApi();

const formSent = ref(false);
const loading = ref(false);
const hasError = ref(false);

const connectionPublicUser = async () => {
  try {
    const data = await user.publicUser();
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

const submitForm = async (e) => {
  try {
    if (loading.value) {
      return;
    }
    hasError.value = false;
    loading.value = true;

    const fields = getFormFields(e);

    await connectionPublicUser();
    await user.sendResetPasswordEmail(fields.email_user);
    formSent.value = true;
  } catch (error) {
    hasError.value = true;
    console.error(error);
  } finally {
    loading.value = false;
  }
};

onMounted(async () => {
  try {
    store.APP_LOADING = true;
    formSent.value = false;
  } finally {
    store.APP_LOADING = false;
  }
});
</script>

<template lang="pug">
AppCard(padding="lg" elevated v-if="!formSent")
  AppGuestHeader(
    icon="uil uil-lock-alt"
    :title="$t('password_reset.title')"
    :subtitle="$t('password_reset.subtitle')"
  )
  transition(name="alert")
    AppAlert.request-form__alert(
      :title="$t('password_reset.error_title')"
      :subtitle="$t('password_reset.error_subtitle')"
      v-if="hasError"
    )
  form(@submit.prevent="submitForm")
    AppFormInput(
      type="email"
      name="email_user"
      icon="uil uil-envelope"
      :label="$t('lead.email')"
      :disabled="loading"
      required
    )
    AppButton(:loading="loading" :disabled="loading" :label="$t('password_reset.button')")
  .guest-divider
  router-link.guest-action(:to="{ name: 'Login' }")
    i.uil.uil-arrow-left(aria-hidden="true")
    span {{ $t("common.backToLogin") }}
AppAlertCard(:title="$t('password_reset.valid_email')" :subtitle="$t('password_reset.check_mail')" v-else)
</template>

<style lang="scss" scoped>
.request-form {
  &__alert {
    @apply mb-5;
  }
}

.alert-enter-active,
.alert-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.alert-enter-from,
.alert-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>
